import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { utils } from "@alife/cone-arms-core";
import { supportedEntryType } from "./utils";
var requestIdleCallback = utils.requestIdleCallback, getXPath = utils.getXPath, watchPageVisibilityChange = utils.watchPageVisibilityChange, checkWin = utils.checkWin;
var longEventList = [];
export function observeEventDelay() {
    if (!(checkWin() && supportedEntryType("event"))) return;
    var logLongEvent = function(entry) {
        var isFID = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        requestIdleCallback(function() {
            longEventList.push({
                isFID: isFID,
                // 持续时间
                duration: entry.duration,
                // 触发节点
                target: entry.target ? getXPath(entry.target, 5) : "",
                // 事件类型，关联事件的类型
                eventType: entry.name
            });
        });
    }; // 所有操作
    var observer = new PerformanceObserver(function(list) {
        // 只上报有interactionId的，即点击、键盘相关事件：
        // A pointerdown, pointerup, or click belonging to a user tap or drag. Note that pointerdown that ends in scroll is excluded.
        // A keydown or keyup belonging to a user key press.
        // console.log('entries', entries);
        // 过滤不支持interactionId的情况、过滤没有回调函数的行为，过滤1ms以上是因为精度问题，浏览器返回精度高，可能导致出现0点几的情况
        var entries = list.getEntries().filter(function(entry) {
            return entry.interactionId !== undefined && entry.processingStart && entry.processingEnd && entry.processingEnd - entry.processingStart > 1;
        });
        // 对于存在interactionId的事件流只上报最后一个
        var entriesGroup = entries.filter(function(entry) {
            return entry.interactionId !== 0;
        }).reduce(function() {
            var entryListMap = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, entry = arguments.length > 1 ? arguments[1] : void 0;
            var id = entry.interactionId;
            var newEntryListMap = _object_spread({}, entryListMap);
            if (!newEntryListMap[id]) newEntryListMap[id] = [];
            newEntryListMap[id].push(entry);
            return newEntryListMap;
        }, {});
        // eslint-disable-next-line guard-for-in
        for(var i in entriesGroup)// 只上报最后一个，即时间流的最后一个，如pointerdown > pointerup > click，上报最后的click
        logLongEvent(entriesGroup[i][entriesGroup[i].length - 1]);
        entries.filter(function(entry) {
            return entry.interactionId === 0;
        }).forEach(function(entry) {
            logLongEvent(entry);
        });
    });
    try {
        // 老版本浏览器只支持entryTypes
        observer.observe({
            type: "event",
            // @ts-ignore 新特性
            durationThreshold: 100
        });
    } catch (ex) {
    // do nothing
    }
    var observerFID;
    if (supportedEntryType("first-input")) {
        observerFID = new PerformanceObserver(function(list, obs) {
            logLongEvent(list.getEntries()[0], true);
            obs.disconnect();
            observerFID = null;
        });
        observerFID.observe({
            type: "first-input",
            buffered: true
        });
    } // 点击链接跳转的场景渲染等会pending，导致duration特别长，所以在页面切换成不可见时暂停
    var pageVisibilityChangeHandle = function(isVisible) {
        if (!isVisible) {
            // console.log('hide observerFID', observerFID);
            observerFID && observerFID.disconnect();
            observer && observer.disconnect();
        } else setTimeout(function() {
            try {
                observer.observe({
                    type: "event",
                    // @ts-ignore 新特性
                    durationThreshold: 100
                });
            } catch (ex) {
            // do nothing
            }
        }, 100);
    };
    watchPageVisibilityChange(function(isVisible) {
        pageVisibilityChangeHandle(isVisible);
    });
    return {
        reset: function() {
            longEventList = [];
        },
        getLongEventList: function() {
            return longEventList;
        },
        unbind: function() {
            observerFID && observerFID.disconnect();
            observer && observer.disconnect();
            pageVisibilityChangeHandle = function() {};
        }
    };
}
